import { Flex, MediaBox } from "@jewlr/storybook/core"
import loadable from "@loadable/component"
import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import styled from "styled-components"

import { retry, IS_JEWLR } from "helpers/application"
import useWindowDimensions from "helpers/window-dimensions"

import FlipIcon from "./icons/flip-icon"
import Wishlist from "./icons/wishlist"
import WizardPricingLoading from "./loaders/wizard-pricing-loading"
import MainImageSlider from "./main-image-slider"
import ProductPrice from "./product-price"

const ShippingRibbon = loadable(() => retry(() => import("./shipping-ribbon")))

const Container = styled.div`
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 14px 0 #ebebeb;
  flex: 1;
  margin-left: 16px;
  margin-right: 16px;
  padding: 12px 0;
  position: relative;

  ${(props) => props.theme.mediaQueries.mobileOnly`
    margin-top: 0 !important;
  `}
  ${(props) => props.theme.mediaQueries.tablet`
    box-shadow: none;
    margin-left: 0;
    margin-right: 0;
    padding: 0;
    width: auto;
  `}
`
const IconsContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  left: 0;
  padding: 0 16px;
  position: absolute;
  top: 20px;
  width: 100%;
  z-index: 1;
  ${(props) => props.theme.mediaQueries.tablet`
    padding: 0;
    position: static;
    width: 90%;
  `}
`

const ActionContainer = styled(Flex).attrs({
  gutter: 1,
})`
  align-items: center;
  z-index: 1;
`

// const TangibleeContainer = styled(Box).attrs({
//   id: "tangiblee-cta",
// })`
//   .tng-cta-wrapper {
//     margin: 0;
//   }

//   .tng-alt-cta {
//     flex-direction: column-reverse;
//   }

//   .tng-alt-cta:before {
//     background-size: 20px 20px;
//     height: 20px;
//     width: 20px;
//   }
// `

const InternalImageAreaContent = ({
  defaultImage,
  showFlip,
  wizardLoading,
}) => {
  const isMobile = useWindowDimensions().isMobile
  return (
    <Container>
      {isMobile && IS_JEWLR() && <ShippingRibbon />}
      <IconsContainer>
        {IS_JEWLR() && <Wishlist />}
        <ActionContainer>{showFlip && <FlipIcon />}</ActionContainer>
      </IconsContainer>
      <MainImageSlider defaultImage={defaultImage} />
      <MediaBox lessThan="tablet" padding="0 16px">
        <ProductPrice />
      </MediaBox>
      {wizardLoading && (
        <MediaBox lessThan="tablet">
          <WizardPricingLoading />
        </MediaBox>
      )}
    </Container>
  )
}

InternalImageAreaContent.propTypes = {
  defaultImage: PropTypes.object,
  showFlip: PropTypes.bool,
  wizardLoading: PropTypes.string,
}

const mapStateToProps = (state) => {
  return {
    showFlip: state.wizard.hasFaceComponentOptions,
    wizardLoading: state.wizard.loading,
  }
}

const mapDispatchToProps = () => ({})

const ImageAreaContent = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalImageAreaContent)
export default ImageAreaContent
